import { useState, useEffect } from 'react';
import { getCurrentUser, fetchUserAttributes } from '@aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';

export function useAuthUser() {
  const [currentUser, setCurrentUser] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchCurrentUser() {
    try {
      setIsLoading(true);
      const user = await getCurrentUser();
      const attributes = await fetchUserAttributes();
      const email = attributes.email || null;
      
      // Check if user has changed since last use
      const storedUserId = localStorage.getItem('currentUserId');
      const storedEmail = localStorage.getItem('currentUserEmail');
      
      // If user changed, clear previous user's data
      if (storedUserId && (storedUserId !== user.userId || storedEmail !== email)) {
        clearUserData();
        // Store new user info immediately
        localStorage.setItem('currentUserId', user.userId);
        localStorage.setItem('currentUserEmail', email || '');
        localStorage.setItem('userLastLogin', new Date().toISOString());
      }
      
      setCurrentUser(user);
      setUserEmail(email);
      setIsLoading(false);
      return { user, email };
    } catch (err) {
      console.error('Error fetching user:', err);
      setError(err);
      setIsLoading(false);
      setCurrentUser(null);
      setUserEmail(null);
      return null;
    }
  }

  function clearUserData() {
    // Clear ALL user-specific data from localStorage
    localStorage.removeItem('settings');
    localStorage.removeItem('save_slots');
    localStorage.removeItem('previewSettings');
    localStorage.removeItem('currentUserId');
    localStorage.removeItem('currentUserEmail');
  }

  useEffect(() => {
    // Initial user fetch
    fetchCurrentUser();
    
    // Listen for auth events
    const listener = Hub.listen('auth', (data) => {
      const { event } = data.payload;
      
      if (event === 'signedIn') {
        fetchCurrentUser();
      } else if (event === 'signedOut') {
        clearUserData();
        setCurrentUser(null);
        setUserEmail(null);
      }
    });
    
    return () => listener();
  }, []);

  return {
    currentUser,
    userEmail,
    isLoading,
    error,
    refreshUser: fetchCurrentUser,
    clearUserData
  };
}